<template>
  <ScModal
    class="otp-error-modal"
    :show="true"
  >
    <div class="modal-header">
      <h5 class="modal-title">
        İŞLEM GERÇEKLEŞEMEDİ
      </h5>
      <button
        type="button"
        class="close"
        @click="close"
      >
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <img
        class="icon-otpError"
        src="https://cdn.dsmcdn.com/seller-center/onboarding/images/otpError.svg?v=1"
        alt="otp-error"
      >
      <span class="info-text">
        Bilgileri 5 kere yanlış girdiğiniz için süreciniz 1 saat askıya alınmıştır.
      </span>

      <ScButton
        class="submit-btn"
        @click="close"
      >
        1 SAAT SONRA TEKRAR DENE
      </ScButton>
    </div>
  </ScModal>
</template>

<script>

import ScModal from '@trendyol/sc-ui-kit/ScModal';
import ScButton from '@trendyol/sc-ui-kit/ScButton';

export default {
  name: 'OtpErrorModal',

  components: {
    ScModal,
    ScButton,
  },

  methods: {
    close () {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.otp-error-modal{
  position: fixed;
  width: 100vw;
  height: 100vh;

  &::v-deep .modal-dialog{
    width: calc(100% - 1rem);
  }
  .modal-header{
    padding: 30px;
    .modal-title{
      font-size: 20px;
      font-weight: 500;
      color: #273142;
    }
  }
  .modal-body{
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon-otpError{
      height: 125px;
    }
    .info-text{
      margin-top: 24px;
      font-size: 14px;
      color: #6e7787;
    }
    .submit-btn{
      margin: 30px 0;
      width: 100%;
      font-size: 14px;
      &:disabled{
        cursor: not-allowed;
      }
    }
  }
}
</style>
